// router/index.ts
import type { RouteRecordRaw } from 'vue-router'
import DesignerView from '@/views/DesignerView.vue'
import Page404 from '@/views/Page404.vue'

export enum RouteNames {
  CustomImageDesigner = 'CustomImageDesigner',
  PredefinedLabelDesigner = 'PredefinedLabelDesigner',
  LabelAdminDesigner = 'LabelAdminDesigner',
  CartItemDetail = 'CartItemDetail',
}

/**
 * Public routes
 */
export function createPublicRoutes(): RouteRecordRaw[] {
  return [
    { path: '/custom-upload', name: 'CustomUpload', component: () => import('@/views/UploadView.vue') },
    { path: '/image/:imageId', name: RouteNames.CustomImageDesigner, component: DesignerView },
    { path: '/label/:slug', name: RouteNames.PredefinedLabelDesigner, component: DesignerView },

    // Detail cart item -> uz ulozena polozka
    { path: '/cart/:cartItemId', name: RouteNames.CartItemDetail, component: DesignerView },
    // 404 na FE
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: Page404 },
  ]
}

/**
 * Admin/embedded routes – only backend (widget)
 * No 404 page needed; fallback to na /admin/:id
 */
export function createAdminRoutes(): RouteRecordRaw[] {
  return [
    { path: '/admin/:labelId', name: RouteNames.LabelAdminDesigner, component: DesignerView, meta: { adminOnly: true } },
    { path: '/:pathMatch(.*)*', redirect: '/admin/0' },
  ]
}
